import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import {
  ProductSelectors,
  ProductActions,
} from '@products/store/products.slice';
import { ContentStatus } from '@shared/interfaces/content-status';

@Component({
  selector: 'app-product-edit',
  templateUrl: './product-edit.component.html',
  styleUrls: ['./product-edit.component.scss'],
})
export class ProductEditComponent implements OnInit, OnDestroy {
  productId?: string;
  userType?: string;

  isEditMode = false;
  isCreateMode = false;
  isAdminMode = false;
  readOnly = false;
  onlyFirstTab = false;

  navigateFrom:
    | 'ADMIN'
    | 'PRODUCT-ADMIN'
    | 'SORTIMENT'
    | 'PRICING'
    | 'SEARCH'
    | 'ORDER-LIST'
    | 'PRODUCT-TAKE-OVER'
    | 'VIP-DISCOUNTS'
    | '' = '';

  formStatus?: ContentStatus;

  subs = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.subs.add(
      this.route.queryParams.subscribe((params: Params) => {
        if (params['id']) {
          this.productId = params['id'];
        }
        if (params['userType']) {
          this.userType = params['userType'];
        }
        this.subs.add(
          this.route.data.subscribe((data) => {
            this.navigateFrom = data['navigateFrom'];

            this.readOnly = !!data['readOnly'];
            this.isAdminMode = this.navigateFrom === 'ADMIN';
            this.isEditMode = !!this.productId && !this.readOnly;
            this.isCreateMode =
              !this.isEditMode && !this.isAdminMode && !this.readOnly;
            this.onlyFirstTab = !!data['onlyFirstTab'] || this.isCreateMode;
          })
        );
      })
    );

    this.subs.add(
      this.store
        .select(ProductSelectors.selectEditedProduct)
        .subscribe((product) => {
          this.formStatus = product?.status;
        })
    );
  }

  onCancel() {
    const isSelling = this.router.url.includes('selling');
    switch (this.navigateFrom) {
      case '':
        switch (this.formStatus) {
          case 'DRAFT':
            this.router.navigate([
              '/selling/sortiment/product-sortiment/products-start/products/pending',
            ]);
            break;
          case 'PUBLISHED':
            this.router.navigate([
              '/selling/sortiment/product-sortiment/products-start/products',
            ]);
            break;
          case 'REJECTED':
            this.router.navigate([
              '/selling/sortiment/product-sortiment/products-start/products/rejected',
            ]);
            break;
          default:
            this.router.navigate([
              '/selling/sortiment/product-sortiment/products-start/products/pending',
            ]);
            break;
        }
        break;
      case 'ADMIN':
        if (this.isEditMode) {
          this.router.navigate(['/admin/approvals/products/view'], {
            queryParams: { id: this.productId },
          });
        } else {
          this.router.navigate(['/admin/approvals/products']);
        }
        break;
      case 'PRODUCT-ADMIN':
        this.router.navigate(['/admin/products']);
        break;
      case 'SORTIMENT':
        this.router.navigate([
          isSelling ? '/selling' : '/buying',
          'sortiment',
          'products',
        ]);
        break;
      case 'PRICING':
        this.router.navigate(['/selling/prices/pricing/products']);
        break;
      case 'ORDER-LIST':
        this.router.navigate(['/buying/order-list']);
        break;
      case 'PRODUCT-TAKE-OVER':
        this.router.navigate(['/admin/approvals/product-take-over']);
        break;
      case 'VIP-DISCOUNTS':
        this.router.navigate(['/selling/prices/discounts/vip-discounts']);
        break;
      default:
        history.back();
    }
  }

  ngOnDestroy(): void {
    this.store.dispatch(ProductActions.clearEditedProduct.trigger());
    this.subs.unsubscribe();
  }
}
